import { render } from "./loginAdminUp.vue?vue&type=template&id=466faa2e"
import script from "./loginAdminUp.vue?vue&type=script&lang=js"
export * from "./loginAdminUp.vue?vue&type=script&lang=js"

import "./loginAdminUp.vue?vue&type=style&index=0&id=466faa2e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__